import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggersDataInterface } from 'modules/automation-rules/triggers/hooks/use-triggers-data';
import { AutomationRulesTriggersEditType, TriggerFunnelEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { getFunnelStepUrl } from 'modules/funnels/funnel/utils/get-funnel-step-url';
import { getFunnelUrl } from 'modules/funnels/utils/get-funnel-url';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { OpenInNewIcon } from '@systemeio/ui/icons';
interface TriggerFunnelItemProps extends EditTriggerItemInterface<TriggerFunnelEditInterface> {
  funnelDataStr: AutomationRuleTriggersDataEnum;
  funnelStepDataStr: AutomationRuleTriggersDataEnum;
  funnelData: keyof Omit<TriggersDataInterface, 'blogEntityData'>;
  funnelStepData: keyof Omit<TriggersDataInterface, 'blogEntityData'>;
}
const TriggerFunnelItem = t0 => {
  const $ = _c(22);
  const {
    trigger,
    funnelStepDataStr,
    funnelDataStr,
    idx,
    onDelete,
    setRules,
    triggers,
    errors,
    funnelData,
    funnelStepData,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = trigger as AutomationRulesTriggersEditType;
  let t2;
  if ($[0] !== idx || $[1] !== onDelete) {
    t2 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== errors.automationTriggers || $[4] !== funnelData || $[5] !== funnelDataStr || $[6] !== funnelStepData || $[7] !== funnelStepDataStr || $[8] !== idx || $[9] !== isStatic || $[10] !== setRules || $[11] !== t || $[12] !== trigger.funnelStep.funnel || $[13] !== trigger.funnelStep.id || $[14] !== trigger.funnelStep.name || $[15] !== trigger.id || $[16] !== triggers) {
    t3 = t4 => {
      const {
        renderTriggerLabel,
        data,
        onOpen,
        onClear
      } = t4;
      return <><FormSelect disabled={isStatic} onOpen={() => onOpen(funnelDataStr)} label={renderTriggerLabel({
          label: t("dashboard.funnel.title"),
          additionalLabel: trigger.funnelStep.funnel.id ? <LinkWithoutPrefetch href={getFunnelUrl(trigger.funnelStep.funnel.id)} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_funnel")} value={trigger.funnelStep.funnel.id} data={data[funnelData]} staticData={getDataFromObj(trigger.funnelStep.funnel)} onChange={data_0 => {
          setRules(prev => ({
            ...prev,
            triggers: triggers.map((el, i) => {
              if (idx === i) {
                return {
                  ...el,
                  funnelStep: {
                    id: undefined,
                    funnel: {
                      id: data_0
                    }
                  }
                };
              } else {
                return el;
              }
            })
          }));
          onClear(funnelStepDataStr);
        }} error={errors.automationTriggers[trigger.id]?.funnel?.join("")} />{trigger.funnelStep.funnel.id && <FormSelect disabled={isStatic} onOpen={() => onOpen(funnelStepDataStr)} label={renderTriggerLabel({
          label: t("dashboard.funnel.funnel_step"),
          additionalLabel: trigger.funnelStep.funnel.id && trigger.funnelStep.id ? <LinkWithoutPrefetch href={getFunnelStepUrl(trigger.funnelStep.funnel.id, trigger.funnelStep.id)} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_funnel_step")} value={trigger.funnelStep.id} staticData={getDataFromObj({
          id: trigger.funnelStep.id,
          name: trigger.funnelStep.name
        })} data={data[funnelStepData]} onChange={data_1 => setRules(prev_0 => ({
          ...prev_0,
          triggers: triggers.map((el_0, i_0) => {
            if (idx === i_0) {
              return {
                ...el_0,
                funnelStep: {
                  id: data_1,
                  funnel: trigger.funnelStep.funnel
                }
              };
            } else {
              return el_0;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.funnelStep?.join("")} />}</>;
    };
    $[3] = errors.automationTriggers;
    $[4] = funnelData;
    $[5] = funnelDataStr;
    $[6] = funnelStepData;
    $[7] = funnelStepDataStr;
    $[8] = idx;
    $[9] = isStatic;
    $[10] = setRules;
    $[11] = t;
    $[12] = trigger.funnelStep.funnel;
    $[13] = trigger.funnelStep.id;
    $[14] = trigger.funnelStep.name;
    $[15] = trigger.id;
    $[16] = triggers;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t3) {
    t4 = <EditTriggerWrapper trigger={t1} onDelete={t2}>{t3}</EditTriggerWrapper>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
};
export default TriggerFunnelItem;